import {Selector} from 'x.vue.components.ui';
import {CalculatorWoods_, board} from './mixins.js';
import './cw.css';

export const CalculatorWoods_fboard = {
    mixins: [CalculatorWoods_,board],
    components: {selector: Selector},
    data () {
        return {
            config: {
                steps: 2,
                K: 1.15
            },
            vars: {
                boards: {
                        fb28_146_3000: {
                                'title': 'Доска пола 28 х 146 х 2000',
                                'H': 0.146,
                                'L': 2
                            },
                        fb36_146_3000: {
                                'title': 'Доска пола 36 х 146 х 3000',
                                'H': 0.146,
                                'L': 3
                            }
                },
            },
            form: {},
        }
    },
    computed: {
        
        a () {
            return this.form.long||0;
        },
        b () {
            return this.form.width||0;
        },
        
        S () {
            return (this.a*this.b);
        },
        
        K () {
            return this.config.K;
        },
        
        N () {
            let devision = this.bS;
            return devision?(this.S*this.K/devision):0;
        },
        
        
        result () {
            let result = {
                    rows: [],
                    errors: [],
                    total: 0
                };
                
            if (this.a) {
                result.rows.push({
                        'title': 'Длина, м',
                        'value': this.a,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите длину',
                        'step': 1,
                    });
            }
            
            if (this.b) {
                result.rows.push({
                        'title': 'Ширина, м',
                        'value': this.b,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите ширину',
                        'step': 1,
                    });
            }
            
            if (this.board) {
                result.rows.push({
                        'title': 'Материал',
                        'value': this.board.title,
                    });
            } else {
                result.errors.push({
                        'text': 'Выбирите материал пола',
                        'step': 2,
                    });
            }
            
            ///////////////////////// результат
            result.total = Math.ceil(this.N);
            
            return result;
        }
    },
	template: `
	<div>
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 1"
            >
            <a v-bind:name="'step'+(1+stepg-step)"></a>
            <div class="calculator__info">
                
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Укажите размер</span>
                </div>
            </div>
            <div class="params">
                <label class="option-label">
                    <span>Длина, м</span>
                    <input type="number" v-model="form.long">
                </label>
                <label class="option-label">
                    <span>Ширина, м</span>
                    <input type="number" v-model="form.width">
                </label>
            </div>
        </div>
        
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 2"
            >
            <a v-bind:name="'step'+(2+stepg-step)"></a>
            <div class="calculator__info">
                
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Выбирите материал</span>
                </div>
            </div>
            
            <div class="params params--coating">
                <label class="params-select">
                    <span class="params-name">Материал настила:</span>
                    <selector v-model="form.board"
                            v-bind:options="vars.boards"
                            titlekey="title"
                            placeholder="Выбирите материал"
                        />
                </label>
            </div>
        </div>
        
    </div>
	`
}